(() => {
  const initGallery = (section) => {
    const gallery = section.querySelector('[data-qcp-gallery]');
    const main = section.querySelector('[data-qcp-gallery-main]');
    const thumbs = section.querySelector('[data-qcp-gallery-thumbs]');

    if (!gallery || !main || gallery.dataset.qcpGalleryInitialized || typeof Swiper === 'undefined') return;

    let thumbsSwiper;

    if (thumbs) {
      thumbsSwiper = new Swiper(thumbs, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          1024: { spaceBetween: 11 },
        },
      });
    }

    new Swiper(main, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      watchOverflow: true,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    });

    gallery.dataset.qcpGalleryInitialized = 'true';
  };

  const initProductSection = (section) => {
    initGallery(section);

    const form = section.querySelector('.quitting-coffee-product__form');
    const sellingPlanInput = section.querySelector('.quitting-coffee-product__selling-plan');
    const buyButton = section.querySelector('.quitting-coffee-product__add-button');
    const buyButtonPrice = section.querySelector('[data-qcp-button-price]');

    if (!form || !sellingPlanInput || !buyButton) return;

    const updateSelectedVariant = (input) => {
      sellingPlanInput.value = input.dataset.qcpSellingPlan || '';
      buyButton.disabled = input.disabled;

      if (buyButtonPrice) {
        buyButtonPrice.textContent = input.dataset.qcpPrice || '';
      }
    };

    section.querySelectorAll('.quitting-coffee-product__variant-input').forEach((input) => {
      input.addEventListener('change', () => updateSelectedVariant(input));
    });

    const selectedInput = section.querySelector('.quitting-coffee-product__variant-input:checked');
    if (selectedInput) updateSelectedVariant(selectedInput);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (buyButton.disabled) return;

      const formData = new FormData(form);
      const payload = Object.fromEntries(formData.entries());
      const quantity = Number.parseInt(payload.quantity, 10) || 1;
      const cartAddUrl = window.routes?.cartAddUrl || '/cart/add';

      if (!payload.selling_plan) delete payload.selling_plan;
      if (!payload.quantity) payload.quantity = quantity;

      buyButton.disabled = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      try {
        const response = await fetch(cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('Unable to add the product to cart.');

        section.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: { id: payload.id },
              quantity,
            },
          }),
        );
      } catch (error) {
        console.error(error);
      } finally {
        buyButton.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    });
  };

  const init = () => document.querySelectorAll('[data-qcp-product]').forEach(initProductSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-qcp-product]').forEach(initProductSection);
  });
})();
